import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';
import type { ARServiceItem } from '@/models/airRoad';

import { statesTimeZonesList, timeZoneDefault } from '@/utils/PortalConstants';

export function getAirRoadStopItemValue(
  stop: ReadonlyDeep<openapi.AirroadJobDetailedContentOpenapi['stops'][0]>,
): openapi.AirroadSingleCreateBodyOpenapi['ar_stops'][0] {
  return {
    address_line_1: stop.address_line_1,
    address_line_2: stop.address_line_2 || '',
    name: stop.name,
    // TODO is here should be number or object
    // @ts-expect-error
    original_stop: stop.id || NaN,
    postcode: stop.post_code,
    state: stop.state,
    stop_number: stop.stop_number,
    suburb: stop.suburb,
  };
}

export function getDefaultWeight(
  modelProducts: ReadonlyDeep<
    openapi.AirroadSingleCreateBodyOpenapi['items'][0]['products']
  >,
  legProducts: ReadonlyDeep<
    openapi.AirroadJobDetailedContentOpenapi['stops'][0]['pickup_products']
  >,
): number {
  if (!modelProducts) return 0;
  return modelProducts.reduce(function (accumulator, oneModelProduct) {
    const legProduct = legProducts.find(function (oneLegProduct) {
      return oneLegProduct._id === oneModelProduct.product_id;
    });
    return (
      accumulator + (legProduct?.weight || 0) * (oneModelProduct.quantity || 1)
    );
  }, 0);
}

export function getStopTimeZone(
  stop?: ReadonlyDeep<openapi.AirroadJobDetailedContentOpenapi['stops'][0]>,
): string {
  if (!stop) return timeZoneDefault;
  const state = stop.state;
  if (!state) return timeZoneDefault;
  // @ts-expect-error
  const stopTimeZone = statesTimeZonesList[state].timezone || timeZoneDefault;
  return stopTimeZone;
}

export function getARServiceItemDatetime(
  arServiceItemDate: Required<ARServiceItem>['_date'],
  arServiceItemTime: Required<ARServiceItem>['_time'],
  zoneString: string,
): string {
  let hours = arServiceItemTime.hours.toString();
  if (hours.length === 1) hours = '0' + hours;
  let minutes = arServiceItemTime.minutes.toString();
  if (minutes.length === 1) minutes = '0' + minutes;
  const newTimeValue = hours + ':' + minutes + ':00';
  return arServiceItemDate + 'T' + newTimeValue + zoneString;
}
